import React, { useState } from 'react'
import {
  Grid,
  Button,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { useDispatch } from 'react-redux';
import { ModalAddLine, TIPO_LINEA } from './ModalAddLine';
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { LIQUIDACIONES_LINEA_COMPORBANTE } from '../../../../utils/constants';
import { deleteLineaInsumoMasiva, deleteLineaMedicamentoMasiva, deleteLineaPrestacionMasiva, generateExcelLiquidacionesLineas, uploadArchivoEdiLiquidacionesHandler } from '../../../../actions/liquidaciones/liquidaciones';
import { DeleteOutline } from '@material-ui/icons';
import { AlertFinalizadoStepper } from '../../../stepper/AlertFinalizadoStepper';
import { ModalNotaDebitos } from './lineasPrestacion/ModalNotaDebitos';
import ToolbarXLSPDF from '../../../compartidos/ToolbarXLSPDF';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  datosFc: {
    flex: 1,
    marginTop: 15,
    marginLeft: theme.spacing(5),
  },
  button: {
    marginTop: 10,
  },
}));

export const ToolbarLines = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { formatCurrencyPesos, comprobanteSeleccionado, lineaComprobante, disabled } = props;

  const [openModalAddLine, setOpenModalAddLine] = useState(false);
  const [tipoLinea, setTipoLinea] = useState(0);
  const [confirmarEliminar, setConfirmarEliminar] = useState(false);
  const [confirmarDebitoCompleto, setConfirmarDebitoCompleto] = useState(false);
  const [openModalComentarioDebitos, setOpenModalComentarioDebitos] = useState(false);

  const handleChangeFile = (e) => {
    dispatch(
      uploadArchivoEdiLiquidacionesHandler(
        comprobanteSeleccionado?.idComprobante,
        comprobanteSeleccionado?.comprobanteContrato?.idEfectorFacturacion,
        e.target.files[0]
      )
    );
    e.target.value = null;
  };

  const fileFormat = ".csv";
  //"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv";

  return (
    <>
      <input
        style={{ display: "none" }}
        id="selectArchivoExcel"
        accept={fileFormat}
        type="file"
        onChange={handleChangeFile}
      />
      <Grid item xs={12} sm={2} md={2}>
        <Typography className={classes.datosFc}>
          <span><strong>Efector: </strong>{`${comprobanteSeleccionado?.comprobanteContrato?.efectorFacturacion?.razonSocial}`}</span>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={2} md={2}>
        <Typography className={classes.datosFc}>
          <span><strong>Total Comprobante </strong>{`${formatCurrencyPesos(comprobanteSeleccionado?.totalComprobante)}`}</span>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={1} md={1}>
        <Button
          color="primary"
          variant="contained"
          disabled={disabled}
          className={classes.button}
          startIcon={<CloudUploadIcon />}
          onClick={() =>
            document.querySelector(`#selectArchivoExcel`).click()
          }
        >
          Subir Edi
        </Button>
      </Grid>
      <Grid item xs={12} sm={1} md={1}>
        {lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION &&
          <Button
            color="primary"
            variant="contained"
            disabled={disabled}
            className={classes.button}
            onClick={() => {
              setConfirmarDebitoCompleto(true);
            }}
          >
            Débito Completo
          </Button>
        }
        <AlertFinalizadoStepper
          open={confirmarDebitoCompleto}
          pregunta={"Generar débito completo"}
          dialogText={`Esta seguro de generar débito completo en todas las líneas?`}
          buttonCancel={"Cancelar"}
          buttonSubmit={"Confirmar"}
          handleClose={() => setConfirmarDebitoCompleto(false)}
          handleSend={() => {
            //dispatch(debitoCompletoLineasPrestaciones(comprobanteSeleccionado?.idComprobante))
            setOpenModalComentarioDebitos(true)
            setConfirmarDebitoCompleto(false);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={1} md={1}>
        {lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION &&
          <Button
            color="primary"
            variant="contained"
            disabled={disabled}
            className={classes.button}
            onClick={() => {
              setOpenModalAddLine(true);
              setTipoLinea(TIPO_LINEA.CodigoLiquidacion);
            }}
          >
            Agregar Cod.Liq
          </Button>
        }
      </Grid>
      <Grid item xs={12} sm={3} md={3}>
        <Button
          color="primary"
          variant="contained"
          disabled={disabled}
          className={classes.button}
          onClick={() => {
            setOpenModalAddLine(true);
            setTipoLinea(TIPO_LINEA.LineaNomenclador);
          }}
        >
          {`Agregar 
            ${lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION
              ? 'Práctica'
              : lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.INSUMO
                ? 'Insumo'
                : 'Medicamento'
            }
          `}
        </Button>
      </Grid>
      <Grid item xs={12} sm={1} md={1}>
        {lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION &&
          <ToolbarXLSPDF
            handleExportExcel={() => dispatch(generateExcelLiquidacionesLineas(comprobanteSeleccionado?.idComprobante, lineaComprobante ))}
          />
        }
      </Grid>
      <Grid item xs={12} sm={1} md={1}>
        <Button
          color="primary"
          variant="contained"
          disabled={disabled}
          className={classes.button}
          startIcon={<DeleteOutline />}
          onClick={() => {
            setConfirmarEliminar(true);
          }}
        >
          Borrar Todo
        </Button>
      </Grid>
      <AlertFinalizadoStepper
        open={confirmarEliminar}
        pregunta={"Eliminar línea"}
        dialogText={`Esta seguro de eliminar todas las línea?`}
        buttonCancel={"Cancelar"}
        buttonSubmit={"Confirmar"}
        handleClose={() => setConfirmarEliminar(false)}
        handleSend={() => {
          if (lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.INSUMO) {
            dispatch(deleteLineaInsumoMasiva(comprobanteSeleccionado.idComprobante))
          }
          if (lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION) {
            dispatch(deleteLineaPrestacionMasiva(comprobanteSeleccionado.idComprobante))
          }
          if (lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.MEDICAMENTO) {
            dispatch(deleteLineaMedicamentoMasiva(comprobanteSeleccionado.idComprobante))
          }
          setConfirmarEliminar(false);
        }}
      />
      {openModalAddLine &&
        <ModalAddLine
          open={openModalAddLine}
          tipoLinea={tipoLinea}
          lineaComprobante={lineaComprobante}
          esLineaCodigoLiq={tipoLinea === TIPO_LINEA.CodigoLiquidacion}
          comprobanteSeleccionado={comprobanteSeleccionado}
          closeModalHandler={() => {
            setOpenModalAddLine(false);
            setTipoLinea();
          }}
        />
      }
      {openModalComentarioDebitos &&
        <ModalNotaDebitos
          open={openModalComentarioDebitos}
          comprobanteSeleccionado={comprobanteSeleccionado}
          closeModal={() => {
            setOpenModalComentarioDebitos(false);
          }}
        />
      }
    </>
  )
}
